import api from "@/api";
import { isSuccessResponseStatusCode } from "@/api/handler";
import { DigitalSignCommonData } from "@/mixins/crk/interface";

export const $recallOutgoingPaymentRequirements = async (
	body: DigitalSignCommonData
): Promise<boolean> => {
	return api
		.post('payment-requirements/recall', body);
};

export const $createPaymentRequirementsOutgoing = async (
	body: DigitalSignCommonData
) => {
	return api
		.post('payment-requirements/create', body, {
			handler: { returnData: false }
		})
		.then(response => isSuccessResponseStatusCode(response?.status));
};